import { error } from "@sveltejs/kit";
import { documentAPI } from "app/stores/documents_api";
import type { PageLoad } from "./$types";

export const ssr = true;

export const load: PageLoad = async ({ parent, params, fetch }) => {
  const communitySlug = params.community;
  // fetch document data
  const json = await documentAPI.fetchDocument({
    fetch,
    communitySlug,
    uuid: params.uuid,
  });
  // check permission to view space
  if (!json) {
    error(404);
  }
  const { community } = await parent();

  return {
    doc: json,
    og: {
      title: json.title,
      icon: community.logoImage,
      description: "",
      image: community.coverImage,
    },
    isKnowledgeBase: true,
    isFullscreen: false,
  };
};
